import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
const V1ContextContext = /*#__PURE__*/ React.createContext({
    accountId: null,
    apiKey: null,
    betaHeaders: null,
    compartmentId: null,
    liveMode: null
});
// eslint-disable-next-line @stripe-internal/stripe/no-mixed-react-exports
export function useV1Context() {
    return React.useContext(V1ContextContext);
}
export function V1Provider({ accountId, apiKey, betaHeaders, children, compartmentId, liveMode }) {
    const parentValue = React.useContext(V1ContextContext);
    const value = React.useMemo(()=>{
        const resolvedAccountIdValue = accountId === undefined ? parentValue.accountId : accountId;
        const resolvedApiKeyValue = apiKey === undefined ? parentValue.apiKey : apiKey;
        const resolvedBetaHeaders = betaHeaders === undefined ? parentValue.betaHeaders : betaHeaders;
        const resolvedCompartmentIdValue = compartmentId === undefined ? parentValue.compartmentId : compartmentId;
        const resolvedLiveModeValue = liveMode === undefined ? parentValue.liveMode : liveMode;
        return {
            accountId: resolvedAccountIdValue,
            apiKey: resolvedApiKeyValue,
            betaHeaders: resolvedBetaHeaders,
            compartmentId: resolvedCompartmentIdValue,
            liveMode: resolvedLiveModeValue
        };
    }, [
        parentValue,
        accountId,
        apiKey,
        betaHeaders,
        compartmentId,
        liveMode
    ]);
    return /*#__PURE__*/ _jsx(V1ContextContext.Provider, {
        value: value,
        children: children
    });
}

//# sourceMappingURL=v1Context.js.map